import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  setBreadcrumbs,
  ConfirmDeletionModal,
  reduceServerErrors,
  UiToastAdapter,
} from 'src/ui';
import { toast } from 'react-toastify';
import { fetchFIs, getFIs, deleteFI } from '../redux';
import { FIsTable } from '../components';

const FIListPage = ({ setBreadcrumbs, fetchFIs, fis, deleteFI }) => {
  const [loading, setLoading] = React.useState(true);
  const [deletingFI, setDeletingFI] = React.useState(null);
  const fisRef = React.useRef(fis);
  fisRef.current = fis;

  React.useEffect(() => {
    (async () => {
      setBreadcrumbs([{ label: 'FIs', href: '/financial-institutions' }]);

      await fetchFIs();

      setLoading(false);
    })();
  }, []);

  const onDeleteFI = fi => {
    setDeletingFI(fi);
  };

  const onCancelDeleteFI = () => {
    setDeletingFI(null);
  };

  const onConfirmDeleteFI = async () => {
    setLoading(true);
    onCancelDeleteFI();

    await deleteFI(deletingFI.id);

    setLoading(false);
    if (fisRef.current.isError()) {
      return reduceServerErrors(fisRef.current);
    }
    toast(
      UiToastAdapter('Financial Institution archived successfully!', 'success')
    );
    return undefined;
  };

  return (
    <>
      <Columns isMultiline>
        <Column isSize="1/2">
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            FIs
          </MuiTitle>
        </Column>
        <Column isSize="1/2">
          <NavLink
            className="button is-gradient-bright is-long is-pulled-right"
            to="/financial-institutions/add"
          >
            <span className="icon is-left">
              <FontAwesomeIcon icon={['fal', 'plus']} />
            </span>
            <span>Add FI</span>
          </NavLink>
        </Column>
        <Column>
          <FIsTable
            loading={loading}
            fis={fis.items || []}
            onDeleteFI={onDeleteFI}
          />
        </Column>
      </Columns>
      <ConfirmDeletionModal
        isActive={!!deletingFI}
        onClickCancel={onCancelDeleteFI}
        onClickConfirm={onConfirmDeleteFI}
        title={(deletingFI || {}).businessName || ''}
      />
    </>
  );
};

FIListPage.propTypes = {
  setBreadcrumbs: propTypes.func.isRequired,
  fetchFIs: propTypes.func.isRequired,
  deleteFI: propTypes.func.isRequired,
  fis: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    fis: getFIs(state),
  };
}

const connectedFIListPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchFIs,
  deleteFI,
})(FIListPage);

export { connectedFIListPage as FIListPage };
